import { NavItemType } from "./types";

export const cyberSecurityOptions = [
  { value: "offensive_security", label: "Offensive Security" },
  { value: "defensive_security", label: "Defensive Security" },
  { value: "integrated_security", label: "Integrated Security" },
];

export const dataAnalyticsOptions = [
  { value: "data_strategy_consulting", label: "Data Strategy & Consulting" },
  {
    value: "data_visualization_reporting",
    label: "Data Visualization & Reporting",
  },
  { value: "ai_data_security", label: "AI & Data Security" },
];

export const radioOptions = [
  {
    label: "Cyber Security",
    value: "cyber",
  },
  {
    label: "Data Analytics and AI",
    value: "data",
  },
];

export const inputFields = [
  {
    name: "name",
    label: "Name",
    message: "Please enter your name",
  },
  {
    name: "companyName",
    label: "Company Name",
    message: "Please enter your company name",
  },
  {
    name: "email",
    label: "Email Address",
    message: "Please enter your email",
    emailValidation: true,
  },
];
export const contentMap = {
  expertise1: {
    listItems: [
      {
        name: "HubIQ",
        description:
          "AI-enhanced phishing simulations & incident readiness training.",
      },
      {
        name: "GovernAI",
        description:
          "Automates policy management and governance with intelligent AI workflows.",
      },
      {
        name: "CyberScore",
        description:
          "AI-powered engine to assess cyber maturity and suggest real-time improvements.",
      },
      {
        name: "DefendAI",
        description:
          "AI-driven threat detection and rapid response system that safeguards your business in real time.",
      },
    ],
  },
  expertise2: {
    listItems: [
      {
        name: "Apply Cyber",
        description:
          "Your all-in-one cybersecurity suite, combining intelligent tools, automation, and real-time insights etc",
      },
      {
        name: "Cyber Atlas",
        description:
          "Curated cyber threat intelligence, news, and compliance updates",
      },
      {
        name: "Secure Cohort",
        description:
          "Audit collaboration tools and marketplace for assessors and businesses",
      },
      {
        name: "Eazy Audit",
        description:
          "A trusted collaboration hub for managing third-party risks, vendor assessments, and secure supply chains.",
      },
      {
        name: "InsightGrid",
        description: "Real-time data and insight engine for compliance mapping",
      },
      {
        name: "Auto Cert",
        description:
          "Automated compliance tracking for standards like ISO, GDPR, NIST, etc.",
      },
      {
        name: "HubIQ",
        description:
          "AI-enhanced phishing simulations & incident readiness training.",
      },
      {
        name: "GovernAI",
        description:
          "Automates policy management and governance with intelligent AI workflows.",
      },
      {
        name: "CyberScore",
        description:
          "AI-powered engine to assess cyber maturity and suggest real-time improvements.",
      },
      {
        name: "DefendAI",
        description:
          "AI-driven threat detection and rapid response system that safeguards your business in real time.",
      },
    ],
  },
};
export const NAV_ITEMS: NavItemType[] = [
  { label: "Home", href: "/" },
  { label: "Cybersecurity & Compliances", href: "/cybersecurity-compliances" },
  {
    label: "AI Products",
    href: "/product-services",
    children: [
      {
        label: "Membaly",
        badge: "Club Management",
        description:
          "AI-native club management platform for memberships, bookings & member portals.",
        href: "/membaly",
      },
      {
        label: "Timeless Marketing",
        badge: "AI E-Commerce",
        description:
          "Modern AI-first commerce platform for branded merchandise, live catalogues & orders.",
        href: "/timeless-marketing",
      },
      {
        label: "All AI Products & Services",
        badge: "Overview",
        description:
          "Explore our multi-agent architecture, AxesIQ & enterprise platforms.",
        href: "/product-services",
      },
    ],
  },
  { label: "Customer Case Studies", href: "/case-studies" },
  { label: "About Us", href: "/about-us" },
  { label: "Website Exposure Check", href: "/website-security-check" },
];
